import React from 'react';
import { Grid, Icon, Segment } from 'semantic-ui-react';
import EmptyListPlaceholder from '../EmptyListPlaceholder';
import { PhoneUtil } from 'utils';

import './index.scss';

const TransferSearchResults = ({ transferDestinations, isReadingTransferDestinations, onClickTransfer, isTransferringCall, setIsSearchResultsVisible }) => {
    const tranferCall = (destination) => {
        setIsSearchResultsVisible(false);
        onClickTransfer(destination);
    }
    
    return (
        <div className='TransferResults__container'>
            <Segment basic>
                {transferDestinations.length > 0 ? (
                    <Grid>
                        {transferDestinations.map((destination, idx) => {
                            const type = destination.type;
                            return (
                                <Grid.Row
                                    verticalAlign='middle'
                                    key={idx}
                                    columns='equal'
                                    stretched
                                >
                                    <Grid.Column>
                                        <div style={{ display: 'flex', alignItems: 'center' }} className='TransferResults__clipped'>
                                            <Icon className={PhoneUtil.DESTINATION_TYPES_ICONS[type]} style={{marginRight: 5}}/> {type === "direct_extension" && (destination?.first_name || destination?.last_name) ? `${destination.first_name} ${destination.last_name}` : destination.label} {destination?.alias && `(${type !== "company_voicemail" ? 'Ext.' : 'VM Box' } ${destination.alias})`}
                                        </div>
                                    </Grid.Column>
                                    <div style={{ display:'flex', alignItems: 'center' }}>
                                        {type === 'direct_extension' && <Icon className={'fa-solid fa-headset'} size={'large'} disabled style={{marginRight: 20}}/>}
                                        <Icon disabled={isTransferringCall} className={'fa-solid fa-arrow-right'} size={'large'} onClick={() => tranferCall(destination.fs_destination)} style={{marginRight: 20, cursor: 'pointer'}}/>
                                    </div> 
                                </Grid.Row>
                            )
                        })}
                    </Grid>
            ) : (
                isReadingTransferDestinations ? (
                    <Segment basic loading />
                ) : (
                    <EmptyListPlaceholder
                        title={"No results found"}
                        subtitle={' '}
                    />
                )
            )}
            </Segment>
        </div>
    )
}

export default TransferSearchResults;
